import { render, staticRenderFns } from "./TagAlertAssignRules.vue?vue&type=template&id=2b7fb4cd&scoped=true&"
import script from "./TagAlertAssignRules.vue?vue&type=script&lang=ts&"
export * from "./TagAlertAssignRules.vue?vue&type=script&lang=ts&"
import style0 from "./TagAlertAssignRules.vue?vue&type=style&index=0&id=2b7fb4cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fb4cd",
  null
  
)

export default component.exports